import React, { useEffect, useState } from "react";
import logoWhite from "../../assets/images/logo-white.svg";
import ellipse1 from "../../assets/images/icon_login/ellipse1.svg";
import ellipse2 from "../../assets/images/icon_login/ellipse2.svg";
import ellipse3 from "../../assets/images/icon_login/Ellipse3.svg";
import ellipse4 from "../../assets/images/icon_login/Ellipse4.svg";
import vector1 from "../../assets/images/icon_login/vector1.svg";
import eye from "../../assets/images/icon_login/eye.svg";
import eyeclose from "../../assets/images/icon_login/eyeclose.svg";
import { toast } from "react-toastify";
import { forgotPassword } from "../../core/service/api_profile";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BackButton } from "../common/BackButton";

const ComponentForgotPasswordCreate = () => {
  const [typeOldPassword, setTypeOldPassword] = useState("password");
  const [typeNewPassword, setTypeNewPassword] = useState("password");
  const [typeNew2Password, setTypeNew2Password] = useState("password");
  const [newPassword, setNewPassword] = useState("");
  const [newPassword2, setNewPassword2] = useState("");
  const [data, setData] = useState<any>({});
  const navigate = useNavigate();
  const location: any = useLocation();
  const { t } = useTranslation();

  const funTypePassword = async (type: string) => {
    switch (type) {
      case "old":
        if (typeOldPassword == "text") {
          setTypeOldPassword("password");
        } else {
          setTypeOldPassword("text");
        }
        break;
      case "new":
        if (typeNewPassword == "text") {
          setTypeNewPassword("password");
        } else {
          setTypeNewPassword("text");
        }
        break;
      default:
        if (typeNew2Password == "text") {
          setTypeNew2Password("password");
        } else {
          setTypeNew2Password("text");
        }
        break;
    }
  };

  const funForgotPassword = async () => {
    const number = /[0-9]/g;

    if (newPassword.length && newPassword2.length < 6)
      return toast.warning(t("PROFILE.length"));
    else if (!number.test(newPassword && newPassword2))
      return toast.warning(t("PROFILE.number"));

    if (newPassword == "" || newPassword2 == "")
      return toast.warning(t("LOGIN.empty"));

    if (newPassword == newPassword2) {
      var query = {
        newPassword: newPassword,
        otp: data.otp,
        phoneEmail: data.phoneEmail,
        sendVia: data.sendVia,
        reqTime: data.reqTime,
      };
      forgotPassword(query).then((res) => {
        toast.success(t("LOGIN.success"));
        var CryptoJS = require("crypto-js");
        var data = {
          username: query.phoneEmail,
          password: query.newPassword,
        };
        var ciphertext = CryptoJS.AES.encrypt(
          JSON.stringify(data),
          "credential"
        ).toString();
        localStorage.setItem("credential", ciphertext);
        navigate("/login", { replace: true });
      });
    } else {
      toast.warning(t("LOGIN.warn"));
    }
  };
  useEffect(() => {
    console.log(JSON.parse(location?.state?.data));
    setData(JSON.parse(location?.state?.data));
  }, []);

  return (
    <div className="flex min-h-screen font-montserrat">
      <div className="relative overflow-visible w-3/12 sm:w-1/2 md:w-3/12 flex-0 bg-psp-login ">
        <img
          src={ellipse1}
          className="absolute bottom-0 left-0 z-0 select-none"
        />
        <img src={ellipse2} className="absolute top-0 left-0 z-0 select-none" />
        <div className="flex flex-col gap-10 w-full">
          <div className="flex flex-col z-10 gap-8 items-start">
            <img src={vector1} className="ml-32 sm:ml-12 md:ml-32" />
            <div className="px-10 mt-36 sm:px-10  md:px-10 md:mt-20 sm:mt-0">
              <img src={logoWhite} className="z-10 h-14 select-none" />
              <p className="text-white z-10 mt-6 text-xs font-light">
                {t("LOGIN.description")}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="grow p-12 bg-psp-primary relative">
        <img src={ellipse3} className="absolute top-0 -left-72 z-0" />
        <img src={ellipse4} className="absolute bottom-0 right-0 z-0" />
        <div className="w-1/2 md:w-2/3 sm:w-full m-auto">
          <div className="pt-40">
            <h1 className="text-gray-400 text-2xl font-medium select-none">
              Welcome To
            </h1>
            <p className="text-black font-semibold text-4xl select-none">
              PSP Web Dekstop
            </p>
          </div>
          <div className="my-2">
            <h4 className="text-left text-lg font-semibold text-psp-primary select-none">
              {t("LOGIN.new")}
            </h4>
          </div>
          <section className="flex flex-col mt-6">
            <div className="flex flex-col gap-2">
              <h1 className="font-montserrat text-sm text-black leading-5 font-medium pl-1 mb-0">
                {t("LOGIN.newPassword")}
              </h1>
              <div className="relative w-full flex">
                <input
                  type={typeNewPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  value={newPassword}
                  className="px-3 py-2 grow rounded-lg h-10 border-1 border-psp-gray border-solid"
                />
                <img
                  src={typeNewPassword === "text" ? eye : eyeclose}
                  className="font-bold text-black absolute z-10 top-2 right-3 hover:cursor-pointer"
                  onClick={() => funTypePassword("new")}
                />
              </div>
            </div>
            <div className="flex flex-col gap-2 mt-3">
              <h1 className="font-montserrat text-sm text-black leading-5 font-medium pl-1 mb-0">
                {t("LOGIN.newPassword")}
              </h1>
              <div className="relative w-full flex">
                <input
                  type={typeNew2Password}
                  onChange={(e) => setNewPassword2(e.target.value)}
                  value={newPassword2}
                  className="px-3 py-2 grow rounded-lg h-10 border-1 border-psp-gray border-solid"
                />
                <img
                  src={typeNew2Password === "text" ? eye : eyeclose}
                  className="font-bold text-black absolute z-10 top-2 right-3 hover:cursor-pointer"
                  onClick={() => funTypePassword("new2")}
                />
              </div>
            </div>
            <button
              onClick={() => funForgotPassword()}
              className="mt-4 bg-psp-btn-primary text-white font-bold w-full py-2 rounded-lg hover:text-red-600 hover:ring-2 hover:ring-offset-cyan-600  active:bg-psp-active"
            >
              {t("LOGIN.confirm")}
            </button>
            {/* <button
              onClick={() => navigate("/login")}
              className="mt-2 bg-[#FFC31A] text-white font-bold w-full py-2 rounded-lg hover:text-red-600 hover:ring-2 hover:ring-offset-cyan-600  active:bg-psp-active"
            >
              {t("OTHER.back")}
            </button> */}
          </section>
        </div>
      </div>
    </div>
  );
};

export default ComponentForgotPasswordCreate;
